import ImageBuddy from 'imagebuddy';
import SiteEvents from '../util/site-events';

class BlockTimelineTripLogs {
	constructor($block, Swiper) {
		this.$block = $block;
		this.$swiperContainer = this.$block.find('.swiper-container').first();

		ImageBuddy.on('image-loaded', (imgEl) => {
			if (jQuery.contains(this.$swiperContainer.get(0), imgEl) && this.swiperInstance) {
				this.swiperInstance.update();
			}
		});

		this.swiperInstance = new Swiper(this.$swiperContainer.get(0), {
			speed: 400,
			slidesPerView: 3,
			spaceBetween: 42,
			centeredSlides: true,
			direction: 'horizontal',
			navigation: {
				prevEl: this.$block.find('.swiper-button-prev').first().get(0),
				nextEl: this.$block.find('.swiper-button-next').first().get(0)
			},
			loop: true,
			autoHeight: true,
			breakpoints: {
				640: {
					slidesPerView: 1
				},
				1024: {
					slidesPerView: 2
					// spaceBetween: 20
				}
			},
			on: {
				init: function () {
					SiteEvents.imageBuddyUpdate();
				}
			}
		});
	}
}

export default BlockTimelineTripLogs;
